import { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <main style={{ textAlign: 'center', padding: '120px 32px' }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '16px' }}>Something went wrong</h1>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <Link
            to="/"
            onClick={() => this.setState({ hasError: false })}
            style={{ color: 'var(--color-trust)', fontWeight: 500 }}
          >
            Return home
          </Link>
        </main>
      );
    }
    return this.props.children;
  }
}
